// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"0efc068e","919":"b0a8a356"}[chunkId] + ".chunk.js";
};